const rankingItems = [
  { rank: 1, title: '春日华尔兹', category: '韩剧 · 爱情', heat: '987万', trend: 'up', change: '+3' },
  { rank: 2, title: '暗影追踪 第三季', category: '日剧 · 悬疑', heat: '856万', trend: 'up', change: '+1' },
  { rank: 3, title: '首尔恋爱指南', category: '韩剧 · 喜剧', heat: '792万', trend: 'down', change: '-1' },
  { rank: 4, title: '江户物语 特别篇', category: '日剧 · 古装', heat: '723万', trend: 'up', change: '+5' },
  { rank: 5, title: '急诊室的故事', category: '韩剧 · 医疗', heat: '681万', trend: 'up', change: '+2' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热播榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            基于全网热度与用户讨论量实时统计，发现当下最火日韩剧
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.rank}
                href="#media"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold whitespace-nowrap ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-500 text-white'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold font-heading text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                </div>

                <div className="flex items-center gap-2 text-xs">
                  <span
                    className={`font-medium whitespace-nowrap ${
                      item.trend === 'up' ? 'text-primary-600' : 'text-secondary-600'
                    }`}
                  >
                    {item.change}
                  </span>
                  <span className="text-foreground-500 whitespace-nowrap">{item.heat}热度</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}